import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecaptchaScriptComponent } from './recaptcha-script/recaptcha-script.component';
@NgModule({
  declarations: [RecaptchaScriptComponent],
  imports: [CommonModule],
  exports: [RecaptchaScriptComponent],
})
export class RecaptchaModule {}
